<div class="container-fluid mt-4">
  <!-- Main Card Container -->
  <mat-tab-group class="modern-tab-group">
    <!-- User Details Tab -->
    <mat-tab label="User Details">
      <div class="card profile-card">
        <div class="card-header">
          <h3 class="card-title">User Profile</h3>
        </div>

        <div class="card-body">
          <div class="profile-header">
            <div class="profile-info">
              <h2 class="profile-name">{{name}}</h2>
              <div *ngFor="let c of output" class="profile-meta">
                <div class="meta-item">
                  <span class="meta-label">Department:</span>
                  <span class="meta-value">{{c.department}}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">Role:</span>
                  <span class="meta-value">{{c.role}}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">User Type :</span>
                  <span class="meta-value">{{data1.user_type}}</span>
                </div>
              </div>
            </div>

            <div class="profile-actions">
              <button mat-raised-button color="accent" class="action-btn" (click)="openLinkDialog()">
                <i class="fas fa-link me-2"></i>LINK EMPLOYEE
              </button>
              <button mat-raised-button color="primary" class="action-btn" (click)="ChangePassword()">
                <i class="fas fa-edit me-2"></i>EDIT
              </button>
              <button mat-raised-button color="accent" class="action-btn" (click)="SetPrivilege()">
                <i class="fas fa-shield-alt me-2"></i>SET PRIVILEGES
              </button>
              <button mat-raised-button color="warn" class="action-btn" (click)="addWorkingDays(output1[0].user_id)">
                <i class="fas fa-calendar-plus me-2"></i>ADD WORKING DAYS
              </button>
            </div>
          </div>

          <!-- Change Password Section -->
          <div class="section-container" *ngIf="ChangePasswordShown">
            <h4 class="section-title">
              <i class="fas fa-key me-2"></i>Change Password
            </h4>

            <form class="form-container">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="new_password">New Password</label>
                    <input type="password" class="form-control" id="new_password" placeholder="Enter new password"
                      [(ngModel)]="data.new_password" name="password" (ngModelChange)="valuechange2($event)">
                    <span class="error-message">{{password}}</span>
                  </div>

                  <div class="form-group">
                    <label for="confirm_password">Confirm Password</label>
                    <input type="password" class="form-control" id="confirm_password" placeholder="Confirm password"
                      [(ngModel)]="data.conform_password" name="Cpassword" (ngModelChange)="valuechange3($event)">
                    <span class="error-message">{{conformpassword}}</span>
                    <span class="error-message">{{doesntMatch}}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="check_in">Check-in Time</label>
                    <input type="datetime-local" class="form-control" id="check_in" [(ngModel)]="data1.check_in"
                      name="check_in">
                  </div>

                  <div class="form-group">
                    <label for="check_out">Check-out Time</label>
                    <input type="datetime-local" class="form-control" id="check_out" [(ngModel)]="data1.check_out"
                      name="check_out">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>User Type</label>
                    <select class="form-control" [(ngModel)]="data1.user_type" (ngModelChange)="valuechange5($event)"
                      name="u_type">
                      <option hidden>{{data1.user_type}}</option>
                      <option *ngFor="let item of userTypedropdown">{{item.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <!-- <label>Select Employee</label>
                    <div class="input-group">
                      <input type="search" class="form-control" placeholder="Search employee" name="search"
                        [(ngModel)]="employee_name" (ngModelChange)="valuechange4($event);SearchEmployee();">
                      <button class="btn btn-outline-secondary" type="button" (click)="SearchEmployee()">
                        <i class="fas fa-search"></i>
                      </button>
                    </div> -->

                    <div class="search-results" *ngIf="isShownEmployee">
                      <div *ngFor="let c of employee" class="result-item"
                        (click)="getEmployeeId(c.employee_id,c.employee_name)">
                        {{c.employee_name}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-footer">
                <button class="btn btn-success submit-btn" (click)="PasswordChange()">
                  <i class="fas fa-save me-2"></i>SUBMIT
                </button>
              </div>
            </form>

            <div class="alert alert-success alert-dismissible fade show" *ngIf="isChange" role="alert">
              <i class="fas fa-check-circle me-2"></i>
              {{alert}}
              <button type="button" class="btn-close" (click)="shown()" aria-label="Close"></button>
            </div>
          </div>

          <!-- Privileges Section -->
          <div class="section-container privileage" *ngIf="SetPrivilegesShown">
            <h4 class="section-title">
              <i class="fas fa-shield-alt me-2"></i>Set Privileges
            </h4>

            <div class="privilege-container">
              <div class="privilege-box">
                <label>All Privileges</label>
                <select class="privilege-select" multiple>
                  <option *ngFor="let c of dummy" (click)='AddItem(c);'>{{c}}</option>
                </select>
                <button class="privilege-action-btn" (click)="AddPrivileges()">
                  <i class="fas fa-angle-double-right"></i> Add All
                </button>
              </div>

              <div class="privilege-box">
                <label>Existing Privileges</label>
                <select class="privilege-select" multiple>
                  <option *ngFor="let c of empPrivilage" (click)='RemoveItem(c);'>{{c}}</option>
                </select>
                <button class="privilege-action-btn" (click)="RemovePrivileges()">
                  <i class="fas fa-angle-double-left"></i> Remove All
                </button>
              </div>
            </div>

            <div class="privilege-footer">
              <span class="success-message">{{SucessMessage}}</span>
              <button mat-raised-button color="primary" class="submit-btn" (click)="AddNewPrivileges()">
                <i class="fas fa-sync-alt me-2"></i>Update Privileges
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Attendance Management Tab -->
    <mat-tab label="Attendance Management">
      <div class="card attendance-card">
        <div class="card-header">
          <h3 class="card-title">Attendance Settings</h3>
        </div>

        <div class="card-body">
          <form class="attendance-form" [formGroup]="creationForm" (ngSubmit)="submitAttendance()">
            <div class="row g-4 align-items-stretch">
              <div class="col-md-6 d-flex">
                <div class="detail-section basic-info-section w-100 h-100">
                  <h5 class="section-title"><i class="fas fa-info-circle me-2"></i>Basic Information</h5>
                  <div class="row g-3">
                    <!-- <div class="col-md-6">
                      <div class="form-group">
                        <label for="workin_time" class="required">Work in time</label>
                        <input class="form-control" name="workin_time" type="time" id="workin_time"
                          formControlName="workin_time">
                        <div
                          *ngIf="creationForm.get('workin_time')?.invalid && creationForm.get('workin_time')?.touched"
                          class="error-message">
                          Work In Time is required
                        </div>
                      </div>
                    </div> -->

                    <!-- <div class="col-md-6">
                      <div class="form-group">
                        <label for="workout_time" class="required">Work out time</label>
                        <input class="form-control" type="time" name="workout_time" id="workout_time"
                          formControlName="workout_time">
                        <div
                          *ngIf="creationForm.get('workout_time')?.invalid && creationForm.get('workout_time')?.touched"
                          class="error-message">
                          Work out time is Required
                        </div>
                      </div>
                    </div> -->
                  </div>

                  <!-- <div class="row g-3 mt-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="lunch_in_time">Lunch in time</label>
                        <input class="form-control" name="lunch_in_time" type="time" id="lunch_in_time"
                          formControlName="lunch_in_time">
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="lunch_out_time">Lunch out time</label>
                        <input class="form-control" type="time" name="lunch_out_time" id="lunch_out_time"
                          formControlName="lunch_out_time">
                      </div>
                    </div>
                  </div> -->

                  <div class="row g-3 mt-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="factory_employee_id">Factory Employee Id</label>
                        <input class="form-control" type="text" id="factory_employee_id"
                          formControlName="factory_employee_id">
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="factory_department_id">Factory Department</label>
                        <ng-select [items]="factoryDepartmentdropdown" bindLabel="name" bindValue="_id"
                          id="factory_department_id" formControlName="factory_department_id">
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mt-3">
                    <label class="form-label required">Stock Warehouse</label>
                    <ng-select class="stock-warehouse-select" [items]="departments" bindLabel="warehouse_name"
                      bindValue="_id" [multiple]="true" [searchable]="true" [closeOnSelect]="false"
                      placeholder="Select departments" formControlName="stock_department">
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="col-md-6 d-flex">
                <div class="detail-section w-100 h-100">
                  <h5 class="section-title"><i class="fas fa-chart-line me-2"></i>Performance Metrics</h5>
                  <div class="row g-3 performance-metrics-row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="sales_qualify_value" class="form-label">Sales Qualify</label>
                        <input class="form-control" type="text" name="sales_qualify_value" id="sales_qualify_value"
                          formControlName="sales_qualify_value" placeholder="Enter value">
                        <div
                          *ngIf="creationForm.get('sales_qualify_value')?.invalid && creationForm.get('sales_qualify_value')?.touched"
                          class="error-message">
                          <i class="fas fa-exclamation-circle me-1"></i>Sales qualify value is required
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for="visits_qualify_value" class="form-label">Visits Qualify</label>
                        <input class="form-control" type="text" name="visits_qualify_value" id="visits_qualify_value"
                          formControlName="visits_qualify_value" placeholder="Enter value">
                        <div
                          *ngIf="creationForm.get('visits_qualify_value')?.invalid && creationForm.get('visits_qualify_value')?.touched"
                          class="error-message">
                          <i class="fas fa-exclamation-circle me-1"></i>Visits qualify value is required
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for="visitplan_waiting_qualify_value" class="form-label ">Visit Plan Waiting
                          Qualify</label>
                        <input class="form-control" name="visitplan_waiting_qualify_value" type="text"
                          id="visitplan_waiting_qualify_value" formControlName="visitplan_waiting_qualify_value"
                          placeholder="Enter value">
                        <div
                          *ngIf="creationForm.get('visitplan_waiting_qualify_value')?.errors?.['pattern'] && creationForm.get('visitplan_waiting_qualify_value')?.touched"
                          class="error-message">
                          <i class="fas fa-exclamation-circle me-1"></i>Only numbers are allowed
                        </div>
                        <div
                          *ngIf="creationForm.get('visitplan_waiting_qualify_value')?.errors?.['min'] && creationForm.get('visitplan_waiting_qualify_value')?.touched"
                          class="error-message">
                          <i class="fas fa-exclamation-circle me-1"></i>Minimum value is 1
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for="visitplan_approval_qualify_value" class="form-label ">Planned Visit Qualify</label>
                        <input class="form-control" name="visitplan_approval_qualify_value" type="text"
                          id="visitplan_approval_qualify_value" formControlName="visitplan_approval_qualify_value"
                          placeholder="Enter value">
                        <div
                          *ngIf="creationForm.get('visitplan_approval_qualify_value')?.errors?.['pattern'] && creationForm.get('visitplan_approval_qualify_value')?.touched"
                          class="error-message">
                          <i class="fas fa-exclamation-circle me-1"></i>Only numbers are allowed
                        </div>
                        <div
                          *ngIf="creationForm.get('visitplan_approval_qualify_value')?.errors?.['min'] && creationForm.get('visitplan_approval_qualify_value')?.touched"
                          class="error-message">
                          <i class="fas fa-exclamation-circle me-1"></i>Minimum value is 1
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="row g-4 mt-0">
              <div class="col-12">
                <div class="detail-section w-100">
                  <h5 class="section-title"><i class="fas fa-cog me-2"></i>Settings</h5>
                  <div class="settings-stack">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="is_department_specific"
                        formControlName="is_department_specific">
                      <label class="form-check-label ms-1" for="is_department_specific">Department
                        Specific</label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="is_visit_location_restricted"
                        formControlName="is_visit_location_restricted">
                      <label class="form-check-label ms-1" for="is_visit_location_restricted">Is visit location
                        restricted</label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="is_customer_location_enabled"
                        formControlName="is_customer_location_enabled">
                      <label class="form-check-label ms-1" for="is_customer_location_enabled">Is Customer
                        Location Enabled</label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="is_attendance_exempted"
                        formControlName="is_attendance_exempted">
                      <label class="form-check-label ms-1" for="is_attendance_exempted">Attendance
                        Exempted</label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="has_visitplan_kpi"
                        formControlName="has_visitplan_kpi">
                      <label class="form-check-label ms-1" for="has_visitplan_kpi">Has Visit Plan Kpi</label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="is_location_restricted"
                        formControlName="is_location_restricted">
                      <label class="form-check-label ms-1" for="is_location_restricted">Is location
                        restricted</label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="on_department_warehouse"
                        formControlName="on_department_warehouse">
                      <label class="form-check-label ms-1" for="on_department_warehouse">Own Department
                        Warehouse</label>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="has_kyc_update_permission"
                        formControlName="has_kyc_update_permission">
                      <label class="form-check-label ms-1" for="has_kyc_update_permission">KYC Update
                        Permission</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Weekly Working Days: own full-width row below -->
            <div class="row g-4 mt-0">
              <div class="col-md-12">
                <div class="detail-section">
                  <div class="d-flex justify-content-between align-items-center section-title">
                    <span><i class="fas fa-calendar-week me-2"></i>Weekly Working Days</span>
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="fillAllTimes()">
                      <i class="fas fa-copy me-1"></i>Fill All Days
                    </button>
                  </div>
                  <div class="weekdays-grid-list">
                    <div *ngFor="let day of weeKDays" class="weekday-row">
                      <mat-checkbox [checked]="day.checked" (change)="weekSelected(day)" class="day-checkbox">
                        {{ day.week }}
                      </mat-checkbox>

                      <div class="day-time-row" *ngIf="day.checked">
                        <div class="time-field">
                          <label class="small mb-0 d-block">Work in</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workin_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Work out</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.workout_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Lunch in</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_in_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="time-field">
                          <label class="small mb-0 d-block">Lunch out</label>
                          <input class="form-control form-control-sm" type="time" [(ngModel)]="day.lunch_out_time"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <button type="submit" class="btn btn-primary submit-btn">
                <i class="fas fa-save me-2"></i>Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </mat-tab>

    <!-- Customer Classification Tab -->
    <mat-tab label="Customer Classification">
      <div class="card user-type-card">
        <div class="card-header">
          <div class="row align-items-center">
            <div class="col-md-6">
              <h3 class="card-title mb-0">
                <i class="fas fa-users-cog me-2"></i>Customer Classification Listing
              </h3>
            </div>
            <div class="col-md-6 d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-primary" (click)="openCreateModal()">
                <i class="fas fa-plus me-2"></i>Add
              </button>

            </div>
          </div>
        </div>

        <div class="card-body">
          <!-- SIMPLE FIX - Replace just the search bar -->
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="simple-search-box">
                <i class="fas fa-search search-icon"></i>
                <input type="text" class="form-control" placeholder="Search industries..."
                  [(ngModel)]="searchIndustryTerm" (ngModelChange)="filterDisplayedIndustries()"
                  (keyup)="filterDisplayedIndustries()" />
              </div>
              <div class="search-info mt-1">
                <small class="text-muted">
                  Showing {{filteredAppIndustryTiers?.length || 0}} of {{appIndustryTiers?.length || 0}} industries
                </small>
              </div>
            </div>
          </div>

          <!-- Classifications Listing -->
          <div class="table-responsive">
            <table class="table classification-table">
              <thead class="table-light">
                <tr>
                  <th scope="col">APP INDUSTRY</th>
                  <th scope="col">TIER NAME</th>
                  <th scope="col">FROM</th>
                  <th scope="col">TO</th>
                  <th scope="col" class="text-end">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let industry of filteredAppIndustryTiers">
                  <ng-container *ngIf="industry.tier_levels && industry.tier_levels.length > 0">
                    <tr *ngFor="let tier of industry.tier_levels; let i = index">
                      <td *ngIf="i === 0" [attr.rowspan]="industry.tier_levels.length" class="align-middle">
                        <strong>{{ industry.app_industry_name }}</strong>
                      </td>

                      <td>
                        <span class="badge" [ngClass]="getTierBadgeClass(tier.label)">
                          <img *ngIf="tier.label === 'Diamond'" src="assets/tier images/diamond.png" alt="Diamond"
                            class="tier-icon">
                          <img *ngIf="tier.label === 'Gold'" src="assets/tier images/gold.png" alt="Gold"
                            class="tier-icon">
                          <img *ngIf="tier.label === 'Silver'" src="assets/tier images/sILVER.png" alt="Silver"
                            class="tier-icon">
                          <img *ngIf="tier.label === 'Bronze'" src="assets/tier images/bronze.png" alt="Bronze"
                            class="tier-icon">
                          {{ tier.label }}
                        </span>
                      </td>

                      <td>
                        <span class="value-display">{{ tier.from | number }}</span>
                      </td>

                      <td>
                        <span class="value-display">{{ tier.to | number }}</span>
                      </td>

                      <td class="text-end align-middle" *ngIf="i === 0" [attr.rowspan]="industry.tier_levels.length">
                        <button type="button" class="btn btn-sm btn-outline-primary me-2"
                          (click)="editIndustryClassification(industry)">
                          <i class="fas fa-edit me-1"></i>Edit
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger"
                          (click)="removeIndustryFromListing(industry.app_industry_id)">
                          <i class="fas fa-trash me-1"></i>Remove
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>

                <tr *ngIf="filteredAppIndustryTiers.length === 0">
                  <td colspan="5" class="text-center py-5">
                    <div class="empty-state-content">
                      <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                      <p class="text-muted">No customer classifications found.</p>
                      <button type="button" class="btn btn-primary mt-3" (click)="openCreateModal()">
                        <i class="fas fa-plus me-2"></i>Create First Classification
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="alert alert-info mt-3" *ngIf="appIndustryTiers.length > 0">
            <i class="fas fa-info-circle me-2"></i>
            <strong>{{ appIndustryTiers.length }}</strong> industr{{ appIndustryTiers.length === 1 ? 'y' : 'ies' }}
            configured with
            <strong>{{ getTotalTiersCount() }}</strong> total tier{{ getTotalTiersCount() === 1 ? '' : 's' }}
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Create New Industry Modal -->
<div class="modal-overlay" *ngIf="showCreateModal" (click)="closeCreateModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-plus-circle me-2"></i>
          Create New Classification
        </h5>
        <button type="button" class="btn-close" (click)="closeCreateModal()"></button>
      </div>

      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label fw-semibold">Select Industry</label>
          <ng-select [(ngModel)]="newIndustryId" [items]="appIndustries" bindLabel="app_industry_name"
            bindValue="app_industry_id" [searchable]="true" placeholder="Choose an industry..." class="form-select-sm">
          </ng-select>
        </div>

        <div class="mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="form-label fw-semibold">Tier Levels</label>
          </div>

          <div class="tier-list">
            <div class="tier-item mb-3" *ngFor="let tier of newIndustryTiers; let i = index">
              <div class="row g-2 align-items-center">
                <div class="col-4">
                  <label class="form-label small mb-1">Tier Name</label>
                  <input type="text" class="form-control form-control-sm" [value]="tier.label" readonly>
                </div>

                <div class="col-4">
                  <label class="form-label small mb-1">From</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="tier.from" min="0"
                    placeholder="0">
                  <div class="invalid-feedback d-block small" *ngIf="tier.from < 0">
                    <i class="fas fa-exclamation-circle me-1"></i> Cannot be negative
                  </div>
                </div>

                <div class="col-4">
                  <label class="form-label small mb-1">To</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="tier.to" min="0"
                    placeholder="0">
                  <div class="invalid-feedback d-block small" *ngIf="tier.from < 0">
                    <i class="fas fa-exclamation-circle me-1"></i> Cannot be negative
                  </div>
                </div>
              </div>
              <div class="row mt-1" *ngIf="i < newIndustryTiers.length - 1">
                <div class="col-12">
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" (click)="closeCreateModal()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary btn-sm" (click)="saveNewIndustryClassification()">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Classification Modal -->
<div class="modal-overlay" *ngIf="showEditModal" (click)="closeEditModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-edit me-2"></i>
          Edit Classification - {{ editingIndustry?.app_industry_name }}
        </h5>
        <button type="button" class="btn-close" (click)="closeEditModal()"></button>
      </div>

      <div class="modal-body" *ngIf="editingIndustry">
        <div class="mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="form-label fw-semibold">Tier Levels</label>
          </div>

          <div class="tier-list">
            <div class="tier-item mb-3" *ngFor="let tier of editingIndustry.tier_levels; let i = index">
              <div class="row g-2 align-items-center">
                <div class="col-4">
                  <label class="form-label small mb-1">Tier Name</label>
                  <input type="text" class="form-control form-control-sm" [value]="tier.label" readonly>
                </div>

                <!-- In the edit modal -->
                <!-- ✅ SIMPLIFIED - Just use two-way binding -->
                <div class="col-4">
                  <label class="form-label small mb-1">From</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="tier.from" min="0"
                    placeholder="0">
                  <div class="invalid-feedback d-block small" *ngIf="tier.from < 0">
                    <i class="fas fa-exclamation-circle me-1"></i> Cannot be negative
                  </div>
                </div>

                <div class="col-4">
                  <label class="form-label small mb-1">To</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="tier.to" min="0"
                    placeholder="0">
                  <div class="invalid-feedback d-block small" *ngIf="tier.to < 0">
                    <i class="fas fa-exclamation-circle me-1"></i> Cannot be negative
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="i < editingIndustry.tier_levels.length - 1">
                <div class="col-12">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" (click)="closeEditModal()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary btn-sm" (click)="saveEditedClassification()">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Link Employee Modal - Simplified Version -->
<div class="modal-overlay" *ngIf="showLinkDialog" (click)="closeLinkDialog()">
  <div class="modal-dialog modal-md" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-link me-2"></i>
          Link Temporary Employee to Permanent Employee
        </h5>
        <button type="button" class="btn-close" (click)="closeLinkDialog()"></button>
      </div>

      <div class="modal-body" style="overflow: visible;">
        <div class="form-group mb-3" style="position: relative;">
          <label class="form-label fw-semibold">New / Permanent Employee</label>
          <div class="input-group" style="display: flex; flex-wrap: nowrap;">
            <input type="search" class="form-control" placeholder="Search employee..." [(ngModel)]="newEmployeeSearch"
              (ngModelChange)="searchNewEmployee()" style="flex: 1; border-radius: 4px 0 0 4px;">
            <button class="btn btn-outline-secondary" type="button" (click)="searchNewEmployee()"
              style="flex-shrink: 0; border-radius: 0 4px 4px 0;">
              <i class="fas fa-search"></i>
            </button>
          </div>
          <span class="error-message">{{newEmployeeError}}</span>

          <div class="search-results" *ngIf="isShownNewEmployee">
            <div *ngFor="let emp of newEmployeeList" class="result-item"
              (click)="selectNewEmployee(emp.employee_id, emp.employee_name)">
              {{emp.employee_name}}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" (click)="closeLinkDialog()">
          Cancel
        </button>
        <button type="button" class="btn btn-success btn-sm" (click)="submitLink()">
          <i class="fas fa-link me-2"></i>Link Employees
        </button>
      </div>
    </div>
  </div>
</div>